/**
 * App module
 * @module app/index
 */

import actions from './actions';
import menus from './menus';
import MenuView from '@netx/core-app/views/menuView';
import controller from './controller';
import {RegisterLegacyAction} from '@netx/core/legacyActionManager';
import {setGlobal} from '@netx/core-next/utils/setGlobal';
import {addMenus} from '@netx/core/legacyMenuManager';

/**
 * @property {object}   exports             - Our module exports
 * @property {string}   exports.namespace   - Module namespace
 * @property {function} exports.initialize  - Module initializer
 */
export default {
	namespace: 'app',
	initialize() {
		RegisterLegacyAction(actions);

		addMenus(menus);

		setGlobal((Netx) => ({
			Views: {
				...Netx.Views,
				MenuView,
			},
		}));

		return controller.initialize();
	},
};
